export default __webpack_public_path__ + "static/media/dtmf-0.870e10bc.mp3";